<template>
  <dash-page-new
      :title="$t('CreateOrder')"
  >
    <ws-accordion class="mt-6" :items="orderNavigation">
      <template #item.order>
        <div class="pa-4">
          <h4>Номер замовлення: FT_234234234</h4>
          <div class="d-flex align-center mt-5">
            <ws-select

                width="300px"
                label="Клієнт"
                placeholder="Оберіть клієнта"
                icon="mdi-search"
                :items="clientsList"
                autocomplete
            />
<!--            <v-btn dark class="noCaps mt-6 ml-5" :color="wsATTENTION">Створити обліковий запис</v-btn>-->
          </div>

            <ws-select
                class="mt-3"
                width="300px"
                label="Тип доставки"
                placeholder="Тип доставки"
                icon="mdi-search"
                :items="deliveryTypes"
            />

        </div>

      </template>
      <template #item.cart>

        <ws-data-table
          :items="cart"
          :headers="cartHeaders"
        >
          <template #item.product_name="{item}">
            <h5>{{ item.product_name }}</h5>
          </template>

          <template #footer>
            <div class="pa-4 d-flex justify-center">
              <v-btn block dark class="noCaps" :color="wsACCENT">
                <v-icon>mdi-plus</v-icon>
                {{ $t('AddProduct') }}
              </v-btn>
            </div>
            <div class="pa-4">
              <h4 class="text-right font-weight-medium">{{ $t('Total')  }} : 1700 {{ BUSINESS_CURRENCY }} </h4>
              <div class="d-flex align-center justify-end">
                <h5 class="mr-5">Списати бонуси : </h5>
                <ws-text-field width="200" class="mr-5" placeholder="0">
                  <template #append>
                    <span class="mt-1 text-no-wrap">з 250</span>
                  </template>
                </ws-text-field>
                <h4 class="text-right">{{ $t('До сплати')  }} : 1500 {{ BUSINESS_CURRENCY }} </h4>
              </div>

            </div>

          </template>

        </ws-data-table>

      </template>
    </ws-accordion>
  </dash-page-new>
</template>

<script>
export default {
  name: "CreateOrder",
  data() {
    return {
      clientsList : [
        { text : "Jeff Bezos (+380637534330)" , value : "+380637534330" },
        { text : "Elon Musk (+380637532343)" , value : "+380637534320" }
      ],
      deliveryTypes : [
        { text : "Торгова точка" , value : "self" }
      ],
      cart : [
        {
          product_name : "Daily SUN CREAM SPF 30PA+++",
          quantity : 2,
          price : '850 грн',
          price_total : '1700 грн'
        }
      ]
    }
  },
  computed : {
    cartHeaders() {
      return [
        { text : "Товар" , value : "product_name" },
        { text : "Кількість" , value : "quantity" },
        { text : "Вартість" , value : "price" },
        { text : "Загальна вартість" , value : "price_total" }
      ]
    },
    orderNavigation() {
      return [
        { name : this.$t('Order') , value : 'order' , icon : 'mdi-receipt-text-check-outline' , expand : true },
        { name : this.$t('Cart')  , value : 'cart'  , icon : 'mdi-cart'                       , expand : true }
      ]
    }
  }
}
</script>

<style scoped>

</style>